module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "information-container"
  }, [_c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": function($event) {
        return _vm.addNormativeAct()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить ресурс\n      ")])]), _vm._v(" "), (_vm.documentsData) ? _c('draggable', {
    staticClass: "columns is-multiline documents",
    model: {
      value: (_vm.documentsData),
      callback: function($$v) {
        _vm.documentsData = $$v
      },
      expression: "documentsData"
    }
  }, _vm._l((_vm.documentsData), function(document) {
    return _c('NormativeActItem', {
      key: document.id,
      attrs: {
        "object": document
      }
    })
  }), 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5307ae35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/NormativeActs.vue
// module id = 948
// module chunks = 0